import { memo, useCallback, useMemo } from "react";

import { cn } from "@/lib/chillnn/cn";
import type { PlainFontFamily } from "@/lib/gql/__generated__/graphql";

import * as Shared from "@/components/features/design/plain/ui/components/main/_shared";

type Props = {
	// card が表示する font-family
	target: PlainFontFamily;
	// 選択中の font-family
	current: PlainFontFamily;

	onClickCard: (value: PlainFontFamily) => void;
};

export const FontCard = memo(({ target, current, onClickCard }: Props) => {
	const fontFamilyClassName = useMemo(() => Shared.Constants.PlainFontFamilyClassNames[target], [target]);
	const fontFamilyName = useMemo(() => Shared.Constants.PlainFontFamilyNames[target], [target]);
	const active = useMemo(() => current === target, [current, target]);

	const handleClickCard = useCallback(() => {
		onClickCard(target);
	}, [onClickCard, target]);

	return (
		<div className={cn(fontFamilyClassName)} style={{ fontFamily: fontFamilyClassName }}>
			<h5>{fontFamilyName}</h5>

			<div
				className={cn(
					"box-border w-full cursor-pointer rounded-lg border-[3px] border-zinc-400 p-2 hover:opacity-60",
					active && "border-brand",
				)}
				onClick={handleClickCard}
			>
				<p>飾られたモリーオ市</p>
				<p>lorem ipsum</p>
				<p>LOREM IPSUM</p>
			</div>
		</div>
	);
});
